// import axios from '@/axios'

import institutionRequests from '@/api/requests/institution.js'
import roleRequests from '@/api/requests/role.js'
import intranetUserRequests from '@/api/requests/intranetUser.js'
import tagRequests from '@/api/requests/tag.js'
import tagTypeRequests from '@/api/requests/tagType.js'
import questionRequests from '@/api/requests/question.js'
import mediaContentRequests from '@/api/requests/mediaContent.js'
import authRequests from '@/api/requests/auth.js'
import articleRequests from '@/api/requests/articles.js'

import portalUserRequests from '@/api/requests/portalUser.js'
import portalConfigRequests from '@/api/requests/portalConfig.js'

import maintainers from '@/api/requests/maintainers'

import educationSystem from './requests/hierarchy/educationSystem'
import educationStage from './requests/hierarchy/educationStage'
import grade from './requests/hierarchy/grade'
import gradeSubject from './requests/hierarchy/gradeSubject'
import gradeVolume from './requests/hierarchy/gradeVolume'
import gradeUnits from './requests/hierarchy/units'
import textbooks from './requests/hierarchy/textbook'
import exams from './requests/exam'
import feedbackReports from './requests/feedbackReports'
import activities from './requests/activities'

export default {
  // axios,
  // login /logout / permissions / me
  ...authRequests,

  statusType () {
    const types = [
      { statusName: 'Inativo', value: 0 },
      { statusName: 'Ativo', value: 1 }
    ]
    return types
  },
  // textbooks
  ...textbooks,
  // grade units
  ...gradeUnits,
  // grade volumes
  ...gradeVolume,
  // grade subjects
  ...gradeSubject,
  // grades
  ...grade,
  // education stages
  ...educationStage,
  // V2 Education System
  ...educationSystem,
  // V2 Maintainers
  ...maintainers,
  // Portal Users
  ...portalUserRequests,
  // Portal Config
  ...portalConfigRequests,
  // articles
  ...articleRequests,
  // exams ( av nacional v2 )
  ...exams,

  // Institutions
  ...institutionRequests,

  // Roles
  ...roleRequests,

  // intranetUser
  ...intranetUserRequests,

  // media contents
  ...mediaContentRequests,

  // settings portal
  // Question Board
  ...questionRequests,
  // tags-types
  ...tagTypeRequests,
  // tags
  ...tagRequests,
  // feedback reports
  ...feedbackReports,
  // activities
  ...activities

}
